import { ApiClient } from "./../core/infra/api-client";

export abstract class BaseService {
  protected api: ApiClient;
  constructor() {
    this.api = new ApiClient();
  }
}
